var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlayerUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6716 9.97156C12.7484 9.74219 14.4297 8.06031 14.6591 5.98312C14.9603 3.24844 12.8291 0.9375 10.1559 0.9375C7.65406 0.9375 5.625 2.96438 5.625 5.4675V5.46969C5.625 8.14344 7.9375 10.2728 10.6716 9.97156ZM10.0009 11.25C6.97625 11.25 0.9375 12.9944 0.9375 16.4591V18.4122C0.9375 18.7725 1.22812 19.0625 1.58406 19.0625H18.4156C18.5008 19.0623 18.5851 19.0453 18.6637 19.0125C18.7423 18.9797 18.8137 18.9318 18.8738 18.8714C18.9339 18.811 18.9815 18.7393 19.0138 18.6605C19.0462 18.5818 19.0627 18.4974 19.0625 18.4122V16.4591C19.0647 12.9966 13.0259 11.25 10.0009 11.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayerUser);
export default __webpack_public_path__ + "static/media/VideoPlayerUser.1031f1faba220caab6cd75fb1bfa72cd.svg";
export { ForwardRef as ReactComponent };